module.exports = __webpack_public_path__ + "assets/img/btn-detail-fa88ad27.png";